import "./ToolTip.scss";
import QuestionMark from "../../../../../../assets/icons/QuestionMark.svg";
import { useRef, useEffect } from "react";

function ToolTip({ title, index, isActive, onClick }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        onClick(-1);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef, onClick]);

  const handleClick = () => {
    onClick(index);
  };

  return (
    <div className="toolTipContainer" ref={containerRef}>
      <img
        src={QuestionMark}
        alt="info"
        className="toolTipIcon"
        onClick={handleClick}
      />
      {isActive && (
        <div className="toolTipContent" onClick={handleClick}>
          {title}
        </div>
      )}
    </div>
  );
}

export default ToolTip;
